var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VButton',{staticClass:"remove-btn",attrs:{"blurOnClick":""},on:{"click":_setup.handleClick}},[_c('TrashcanIcon'),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.removeButtonText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }